/* lv-sx · behaviour for the page rebuild (draft 29.10.2026). Vanilla, no dependencies.
   1 hero headline that matches the ad the visitor came from (utm_content / utm_campaign / utm_term keywords)
   2 results gallery: show the raw file, previous / next
   3 library: "which editions do you own?" -> missing film stocks, what each edition adds
   4 catch sheet on phones for ad visitors, after they have looked around (never on entry) */
(() => {
  if (window.__lvsx) return; window.__lvsx = true;
  const ss = { get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} } };
  const ls = { get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
  const q = new URLSearchParams(location.search);

  /* 1 · hero angle ------------------------------------------------------- */
  const adText = ['utm_content', 'utm_campaign', 'utm_term'].map((k) => q.get(k) || '').join(' ').toLowerCase();
  if (adText.trim()) ss.set('lvsx-ad', adText);
  const fromAd = /facebook|instagram|^ig$|^fb$|meta/i.test(q.get('utm_source') || '') || q.has('fbclid') || ss.get('lvsx-paid') === '1';
  if (fromAd) ss.set('lvsx-paid', '1');
  const angleText = adText.trim() ? adText : (ss.get('lvsx-ad') || '');
  document.querySelectorAll('[data-sx-hero]').forEach((hero) => {
    if (!angleText) return;
    const opts = [...hero.querySelectorAll('template[data-sx-angle]')];
    const hit = opts.find((t) => t.dataset.sxAngle.split(',').map((s) => s.trim().toLowerCase()).filter(Boolean).some((k) => angleText.includes(k)));
    if (!hit) return;
    const frag = hit.content;
    const h = frag.querySelector('[data-h]'); const l = frag.querySelector('[data-l]');
    if (h && h.textContent.trim()) hero.querySelector('[data-sx-h]').textContent = h.textContent.trim();
    if (l && l.textContent.trim() && hero.querySelector('[data-sx-l]')) hero.querySelector('[data-sx-l]').textContent = l.textContent.trim();
    hero.dataset.sxShown = hit.dataset.sxAngle;
  });

  /* 2 · results ---------------------------------------------------------- */
  let looked = false;
  const markLooked = () => { looked = true; };
  document.querySelectorAll('[data-sx-res]').forEach((root) => {
    const track = root.querySelector('[data-sx-track]');
    root.querySelectorAll('[data-sx-raw]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const card = btn.closest('.lvsx-res__card');
        const on = !card.classList.contains('is-raw');
        card.classList.toggle('is-raw', on);
        btn.setAttribute('aria-pressed', String(on));
        btn.querySelector('[data-label]').textContent = on ? btn.dataset.film : btn.dataset.raw;
        markLooked();
      });
    });
    root.querySelectorAll('[data-sx-rx]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const card = btn.closest('.lvsx-res__card');
        const on = !card.classList.contains('is-rx');
        card.classList.toggle('is-rx', on);
        btn.setAttribute('aria-expanded', String(on));
        markLooked();
      });
    });
    root.querySelectorAll('[data-sx-step]').forEach((b) => b.addEventListener('click', () => {
      const card = track.querySelector('.lvsx-res__card');
      const w = card ? card.getBoundingClientRect().width + 12 : 300;
      track.scrollBy({ left: Number(b.dataset.sxStep) * w, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }));
    if (track) {
      let start = 0;
      track.addEventListener('scroll', () => { if (Math.abs(track.scrollLeft - start) > 150) markLooked(); }, { passive: true });
    }
  });

  /* 2d · full screen (Fassung 2, 29.10.): film, exposure, scanner and camera as a fact row on top, raw against
     profile as a drag slider (raw left, film right, like the hero), recipe beside the photo on desktop */
  // sections with the same data-sx-join (the gallery parts) share one full-screen view over all their photos
  const lbRoots = [], joined = {};
  document.querySelectorAll('[data-sx-res]').forEach((el) => {
    const j = el.dataset.sxJoin;
    if (!j) { lbRoots.push([el]); return; }
    if (!joined[j]) { joined[j] = []; lbRoots.push(joined[j]); }
    joined[j].push(el);
  });
  lbRoots.forEach((group) => {
    const root = group[0];
    const cards = group.flatMap((el) => [...el.querySelectorAll('.lvsx-res__card[data-sx-full]')]);
    if (!cards.length) return;
    const D = root.dataset;
    const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const lb = document.createElement('div');
    lb.className = 'lvsx-lb'; lb.hidden = true;
    lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<div class="lvsx-lb__top"><div class="lvsx-lb__head" aria-live="polite"><b class="lvsx-lb__film"></b><dl class="lvsx-lb__facts"></dl></div>'
      + '<button class="lvsx-lb__btn lvsx-lb__x" type="button" data-lb-close>×</button></div>'
      + '<div class="lvsx-lb__main"><div class="lvsx-lb__stage">'
      + '<div class="lvsx-lb__cmp"><img class="lvsx-lb__raw" alt="" draggable="false"><div class="lvsx-lb__film-img"><img alt="" draggable="false"></div>'
      + '<span class="lvh-tag lvh-tag--l" data-lb-tag-l></span><span class="lvh-tag lvh-tag--r" data-lb-tag-r></span>'
      + '<div class="lvsx-lb__handle" role="slider" tabindex="0" aria-valuemin="0" aria-valuemax="100"><span class="lvh-compare__knob"><svg viewBox="0 0 22 14" aria-hidden="true"><path d="M7 2 2 7l5 5M15 2l5 5-5 5"/></svg></span></div></div>'
      + '<div class="lvsx-lb__zoom" hidden><img alt="" draggable="false"></div></div>'
      + '<aside class="lvsx-lb__rx"></aside></div>'
      + '<div class="lvsx-lb__bar"><div class="lvsx-lb__grp"><button class="lvsx-lb__btn lvsx-lb__rxbtn" type="button" data-lb-rx aria-expanded="false"></button>'
      + '<button class="lvsx-lb__btn lvsx-lb__zbtn" type="button" data-lb-zoom aria-pressed="false"></button></div>'
      + '<div class="lvsx-lb__grp"><span class="lvsx-lb__count"></span><button class="lvsx-lb__btn" type="button" data-lb-step="-1">←</button><button class="lvsx-lb__btn" type="button" data-lb-step="1">→</button></div></div>';
    document.body.appendChild(lb);
    const $ = (q) => lb.querySelector(q);
    const stage = $('.lvsx-lb__stage'), cmp = $('.lvsx-lb__cmp'), raw = $('.lvsx-lb__raw'), filmWrap = $('.lvsx-lb__film-img'), film = filmWrap.querySelector('img');
    const handle = $('.lvsx-lb__handle'), zoom = $('.lvsx-lb__zoom'), zimg = zoom.querySelector('img'), rxBox = $('.lvsx-lb__rx');
    const bRx = $('[data-lb-rx]'), bZ = $('[data-lb-zoom]'), bX = $('[data-lb-close]');
    bX.setAttribute('aria-label', D.lbClose || 'Close');
    $('[data-lb-step="-1"]').setAttribute('aria-label', D.lbPrev || 'Previous photo');
    $('[data-lb-step="1"]').setAttribute('aria-label', D.lbNext || 'Next photo');
    handle.setAttribute('aria-label', D.lbDrag || 'Drag to compare');
    bZ.textContent = D.lbZoom || '100 %';
    let idx = 0, back = null, ar = 1.5, pos = 50, hasRaw = false;
    const visible = () => cards.filter((c) => c.offsetParent !== null);
    const setPos = (v) => { pos = Math.max(0, Math.min(100, v)); filmWrap.style.clipPath = hasRaw ? 'inset(0 0 0 ' + pos + '%)' : 'none'; handle.style.left = pos + '%'; handle.setAttribute('aria-valuenow', String(Math.round(pos))); };
    const fit = () => { const cs = getComputedStyle(stage); const w = stage.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight), h = stage.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom); if (w <= 0 || h <= 0) return; let cw = Math.min(w, h * ar); cmp.style.width = Math.floor(cw) + 'px'; cmp.style.height = Math.floor(cw / ar) + 'px'; };
    const setZoom = (on) => {
      lb.classList.toggle('is-zoom', on); zoom.hidden = !on; bZ.setAttribute('aria-pressed', String(on)); bZ.textContent = on ? (D.lbFit || 'Fit') : (D.lbZoom || '100 %');
      if (on) { zimg.src = film.src; const go = () => { zimg.style.width = zimg.naturalWidth + 'px'; zimg.style.height = zimg.naturalHeight + 'px'; zoom.scrollLeft = (zimg.naturalWidth - zoom.clientWidth) / 2; zoom.scrollTop = (zimg.naturalHeight - zoom.clientHeight) / 3; }; zimg.complete ? go() : zimg.addEventListener('load', go, { once: true }); }
    };
    const show = (i) => {
      const list = visible(); idx = (i + list.length) % list.length; const c = list[idx], d = c.dataset;
      setZoom(false); ar = +d.sxAr || 1.5; hasRaw = !!d.sxFullBefore;
      film.src = d.sxFull; film.alt = (c.querySelector('.lvsx-res__after') || {}).alt || '';
      raw.hidden = !hasRaw; if (hasRaw) raw.src = d.sxFullBefore;
      lb.classList.toggle('no-raw', !hasRaw); setPos(50);
      $('[data-lb-tag-l]').textContent = D.lbRaw || 'Raw file'; $('[data-lb-tag-r]').textContent = d.sxStock || '';
      $('.lvsx-lb__film').textContent = d.sxStock || '';
      const facts = [[D.lbEv, d.sxEv], [D.lbScanner, d.sxScanner], [D.lbCamera, d.sxCamera], [D.lbCredit, d.sxCredit]].filter((f) => f[1]);
      $('.lvsx-lb__facts').innerHTML = facts.map((f) => '<div><dt>' + esc(f[0]) + '</dt><dd>' + esc(f[1]) + '</dd></div>').join('');
      const rx = c.querySelector('.lvsx-rx'), rb = c.querySelector('[data-sx-rx]');
      rxBox.innerHTML = rx ? rx.outerHTML.replace(/ id="[^"]*"/, '') : '';
      lb.classList.toggle('no-rx', !rx); lb.classList.remove('rx-open'); bRx.setAttribute('aria-expanded', 'false');
      bRx.textContent = rb ? rb.textContent.replace('+', '').trim() : 'Recipe';
      $('.lvsx-lb__count').textContent = (idx + 1) + ' / ' + list.length;
      lb.setAttribute('aria-label', [d.sxStock, d.sxEv, d.sxScanner].filter(Boolean).join(' · '));
      requestAnimationFrame(fit);
    };
    const open = (c) => {
      back = document.activeElement; lb.hidden = false; document.documentElement.classList.add('lvsx-lb-on');
      show(visible().indexOf(c)); bX.focus({ preventScroll: true }); markLooked();
    };
    const close = () => { lb.hidden = true; document.documentElement.classList.remove('lvsx-lb-on'); if (back && back.focus) back.focus({ preventScroll: true }); };
    cards.forEach((c) => { const o = c.querySelector('[data-sx-open]'); if (o) o.addEventListener('click', () => open(c)); });
    bX.addEventListener('click', close);
    lb.querySelectorAll('[data-lb-step]').forEach((b) => b.addEventListener('click', () => show(idx + Number(b.dataset.lbStep))));
    bRx.addEventListener('click', () => { const on = !lb.classList.contains('rx-open'); lb.classList.toggle('rx-open', on); bRx.setAttribute('aria-expanded', String(on)); });
    bZ.addEventListener('click', () => setZoom(!lb.classList.contains('is-zoom')));
    addEventListener('resize', () => { if (!lb.hidden) fit(); });
    // the slider: drag anywhere on the photo, keys on the handle
    let drag = false;
    const at = (e) => { const r = cmp.getBoundingClientRect(); setPos((e.clientX - r.left) / r.width * 100); };
    cmp.addEventListener('pointerdown', (e) => { if (!hasRaw) return; drag = true; cmp.setPointerCapture(e.pointerId); at(e); markLooked(); });
    cmp.addEventListener('pointermove', (e) => { if (drag) at(e); });
    ['pointerup', 'pointercancel'].forEach((t) => cmp.addEventListener(t, () => { drag = false; }));
    handle.addEventListener('keydown', (e) => {
      const k = { ArrowLeft: -5, ArrowRight: 5, Home: -100, End: 100 }[e.key];
      if (k !== undefined) { e.preventDefault(); e.stopPropagation(); setPos(pos + k); }
    });
    // 100 %: drag with the mouse to move around
    let pan = null;
    zoom.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; pan = { x: e.clientX, y: e.clientY, l: zoom.scrollLeft, t: zoom.scrollTop }; zoom.setPointerCapture(e.pointerId); zoom.style.cursor = 'grabbing'; });
    zoom.addEventListener('pointermove', (e) => { if (pan) { zoom.scrollLeft = pan.l - (e.clientX - pan.x); zoom.scrollTop = pan.t - (e.clientY - pan.y); } });
    ['pointerup', 'pointercancel'].forEach((t) => zoom.addEventListener(t, () => { pan = null; zoom.style.cursor = ''; }));
    // swipe beside the photo goes to the next one
    let x0 = null, y0 = 0;
    stage.addEventListener('touchstart', (e) => { x0 = (e.touches.length === 1 && !cmp.contains(e.target) && !lb.classList.contains('is-zoom')) ? e.touches[0].clientX : null; if (x0 !== null) y0 = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (x0 === null) return; const t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });
    lb.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { if (lb.classList.contains('is-zoom')) setZoom(false); else close(); }
      else if (e.key === 'ArrowRight' && e.target !== handle) show(idx + 1);
      else if (e.key === 'ArrowLeft' && e.target !== handle) show(idx - 1);
      else if (e.key === 'Tab') { const f = [...lb.querySelectorAll('button, [tabindex="0"]')].filter((b) => b.offsetParent !== null && !b.hidden); if (!f.length) return; const a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); } }
    });
  });

  /* 2b · proof slider: switch the left image (film scan / Adobe Standard); the slider itself is lv-home.js */
  document.querySelectorAll('[data-sx-proof]').forEach((root) => {
    const cmp = root.querySelector('.lvsx-proof__cmp'), left = root.querySelector('[data-sx-proof-left]'), tag = root.querySelector('[data-sx-proof-tag]');
    const btns = [...root.querySelectorAll('[data-sx-proof-src]')];
    btns.forEach((b) => b.addEventListener('click', () => {
      if (b.getAttribute('aria-pressed') === 'true') return;
      btns.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      cmp.classList.add('is-wait');
      const im = new Image(); im.src = b.dataset.sxProofSrc;
      const swap = () => { left.src = b.dataset.sxProofSrc; left.alt = b.dataset.alt; if (tag) tag.textContent = b.dataset.tag; cmp.classList.remove('is-wait'); };
      (im.decode ? im.decode().catch(() => {}) : Promise.resolve()).then(swap);
      markLooked();
    }));
    if (cmp) cmp.addEventListener('pointerdown', markLooked);
  });
  /* no context menu (right click, Android long press) and no dragging on protected images */
  document.querySelectorAll('[data-sx-nosave]').forEach((el) => {
    el.addEventListener('contextmenu', (e) => e.preventDefault());
    el.addEventListener('dragstart', (e) => e.preventDefault());
  });

  /* 2c · the film table's header row sticks below the theme's sticky header: follow its bottom edge while scrolling */
  if (document.querySelector('.lvsx-mx')) {
    const hdr = document.querySelector('header-component, #header-component, .header');
    let raf = 0;
    const setTop = () => { raf = 0; const b = hdr ? Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) : 0; document.documentElement.style.setProperty('--lvsx-top', b + 'px'); };
    setTop();
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(setTop); }, { passive: true });
    addEventListener('resize', setTop);
  }

  /* 3 · library: owned editions ------------------------------------------ */
  document.querySelectorAll('[data-sx-lib]').forEach((lib) => {
    const eds = [...lib.querySelectorAll('[data-sx-ed]')].map((el) => ({ el, key: el.dataset.sxEd, films: JSON.parse(el.dataset.films || '[]') }));
    const chips = [...lib.querySelectorAll('[data-sx-own]')];
    const out = lib.querySelector('[data-sx-own-out]');
    const rows = [...lib.querySelectorAll('[data-sx-film]')];
    const total = rows.length;
    const T = (k) => (out && out.dataset[k]) || '';
    const apply = () => {
      const owned = new Set(); const ownKeys = chips.filter((c) => c.checked).map((c) => c.value);
      eds.filter((e) => ownKeys.includes(e.key)).forEach((e) => e.films.forEach((f) => owned.add(f)));
      lib.classList.toggle('has-owned', ownKeys.length > 0);
      rows.forEach((r) => {
        const f = r.dataset.sxFilm; const has = owned.has(f);
        r.classList.toggle('is-missing', ownKeys.length > 0 && !has);
        r.querySelectorAll('td.is-in').forEach((td) => td.classList.toggle('is-owned', ownKeys.length > 0 && has));
      });
      eds.forEach((e) => {
        const add = e.films.filter((f) => !owned.has(f)).length;
        e.el.classList.toggle('is-owned', ownKeys.includes(e.key) || (ownKeys.length > 0 && add === 0));
        const a = e.el.querySelector('[data-sx-adds]');
        if (a) a.textContent = ownKeys.includes(e.key) ? T('own') : (add === 0 ? T('none') : (add === 1 ? T('one') : T('many').replace('{n}', add)));
      });
      if (out) {
        if (!ownKeys.length) out.textContent = '';
        else { const miss = total - owned.size; out.innerHTML = T('summary').replace('{have}', '<b>' + owned.size + '</b>').replace('{miss}', '<b>' + miss + '</b>').replace('{total}', total); }
      }
      ls.set('lvsx-owned', ownKeys.join(','));
    };
    const saved = (ls.get('lvsx-owned') || '').split(',').filter(Boolean);
    chips.forEach((c) => { if (saved.includes(c.value)) c.checked = true; c.addEventListener('change', apply); });
    apply();
  });

  /* 4 · catch sheet -------------------------------------------------------- */
  const sheet = document.querySelector('[data-sx-catch]');
  if (sheet) {
    const src = document.querySelector('.lvp, .lvh-hero');
    if (src) { const cs = getComputedStyle(src); ['--lv-cta', '--lv-on-cta'].forEach((v) => { const x = cs.getPropertyValue(v).trim(); if (x) sheet.style.setProperty(v, x); }); }
    const phone = matchMedia('(max-width: 749px)').matches;
    const last = Number(ls.get('lvsx-catch') || 0);
    const quiet = Date.now() - last < 7 * 864e5 || ls.get('lvsx-catch-done') === '1';
    const force = q.get('lvsx_catch') === '1';
    const eligible = force || (phone && fromAd && !quiet);
    if (eligible) {
      let opened = false; const t0 = Date.now(); const minMs = force ? 0 : Number(sheet.dataset.delay || 15) * 1000;
      const prevFocus = { el: null };
      const open = () => {
        if (opened) return; opened = true; prevFocus.el = document.activeElement;
        sheet.hidden = false; requestAnimationFrame(() => sheet.classList.add('is-open'));
        ls.set('lvsx-catch', String(Date.now()));
        const f = sheet.querySelector('input[type=email]'); setTimeout(() => f && f.focus({ preventScroll: true }), 380);
      };
      const close = () => {
        sheet.classList.remove('is-open'); setTimeout(() => { sheet.hidden = true; }, 360);
        if (prevFocus.el && prevFocus.el.focus) prevFocus.el.focus({ preventScroll: true });
      };
      sheet.querySelectorAll('[data-sx-close]').forEach((b) => b.addEventListener('click', close));
      sheet.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
      const signup = sheet.querySelector('lv-signup');
      if (signup) new MutationObserver(() => { if (signup.classList.contains('is-success')) ls.set('lvsx-catch-done', '1'); }).observe(signup, { attributes: true, attributeFilter: ['class'] });
      const ready = () => Date.now() - t0 >= minMs;
      const anchor = document.querySelector('[data-sx-catch-after]');
      let pastAnchor = false;
      if (anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver((en) => en.forEach((x) => { if (x.boundingClientRect.top < 0 || x.isIntersecting) pastAnchor = true; })).observe(anchor);
      }
      const tick = setInterval(() => {
        if (opened) { clearInterval(tick); return; }
        if (force || (ready() && (looked || pastAnchor))) { clearInterval(tick); open(); }
      }, 800);
    }
  }
  /* 2f · sample gallery filters (29.10.): edition (pack colour) and film stock, over all gallery parts; URL ?edition=&film= */
  document.querySelectorAll('[data-sx-gal]').forEach((head) => {
    const key = head.dataset.sxJoin;
    const cards = [...document.querySelectorAll('[data-sx-join="' + key + '"] .lvsx-gal__item')];
    // one grid for all parts, so rows run on across the 50-photo section limit
    const grid = head.querySelector('.lvsx-gal__grid');
    cards.forEach((c) => { if (c.parentNode !== grid) grid.appendChild(c); });
    document.querySelectorAll('[data-sx-join="' + key + '"]').forEach((el) => {
      if (el !== head && !el.querySelector('.lvsx-gal__item, .lvsx-res__foot, .lvsx-gal__ctas')) el.classList.add('lvsx-gal--empty');
    });
    // justified rows: fill each row to the grid width at about the target height; the last row keeps the target height
    const layout = () => {
      const cs = getComputedStyle(head), W = grid.clientWidth;
      const H = parseFloat(cs.getPropertyValue('--rowh')) || 200, G = parseFloat(cs.getPropertyValue('--gap')) || 8;
      if (!W) return;
      const vis = cards.filter((c) => !c.hidden);
      let row = [], sum = 0;
      const put = (items, h) => items.forEach((c) => { c.style.width = Math.floor((+c.style.getPropertyValue('--ar') || 1) * h * 100) / 100 + 'px'; });
      const hOf = (n, s) => (W - G * (n - 1) - 0.5) / s;
      vis.forEach((c) => {
        const ar = +c.style.getPropertyValue('--ar') || 1;
        if (row.length && (sum + ar) * H + G * row.length >= W) {
          // the row is full: end it with or without this photo, whichever lands closer to the target height
          const hWith = hOf(row.length + 1, sum + ar), hWithout = hOf(row.length, sum);
          if (Math.abs(hWithout - H) < Math.abs(hWith - H)) { put(row, hWithout); row = [c]; sum = ar; return; }
          row.push(c); put(row, hWith); row = []; sum = 0; return;
        }
        row.push(c); sum += ar;
        if (sum * H + G * (row.length - 1) >= W) { put(row, hOf(row.length, sum)); row = []; sum = 0; }
      });
      if (row.length) put(row, H);
    };
    let rz; addEventListener('resize', () => { clearTimeout(rz); rz = setTimeout(layout, 120); });
    const edBtns = [...head.querySelectorAll('[data-sx-ed-f]')], stBtns = [...head.querySelectorAll('[data-sx-st-f]')];
    const cnt = head.querySelector('[data-sx-gal-count]'), unit = head.querySelector('[data-sx-gal-unit]');
    const packs = (c) => (c.dataset.sxPacks || '').split(',').map((x) => x.trim()).filter(Boolean);
    let ed = '', st = '';
    const apply = (push) => {
      const inEd = (c) => !ed || packs(c).includes(ed);
      // film chips: only the stocks of the chosen edition
      stBtns.forEach((b) => { const v = b.dataset.sxStF; b.hidden = !!v && !cards.some((c) => inEd(c) && c.dataset.sxStock === v); });
      if (st && !cards.some((c) => inEd(c) && c.dataset.sxStock === st)) st = '';
      let n = 0;
      cards.forEach((c) => { const ok = inEd(c) && (!st || c.dataset.sxStock === st); c.hidden = !ok; if (ok) n++; });
      edBtns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.sxEdF === ed)));
      stBtns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.sxStF === st)));
      layout();
      if (cnt) cnt.textContent = n;
      if (unit) unit.textContent = n === 1 ? unit.dataset.one : unit.dataset.many;
      if (push) {
        const u = new URL(location.href);
        ed ? u.searchParams.set('edition', ed) : u.searchParams.delete('edition');
        const sb = stBtns.find((b) => b.dataset.sxStF === st);
        st && sb ? u.searchParams.set('film', sb.dataset.slug) : u.searchParams.delete('film');
        history.replaceState(null, '', u);
      }
    };
    edBtns.forEach((b) => b.addEventListener('click', () => { ed = b.dataset.sxEdF; apply(true); }));
    stBtns.forEach((b) => b.addEventListener('click', () => { st = b.dataset.sxStF; apply(true); }));
    const q = new URLSearchParams(location.search);
    if (edBtns.some((b) => b.dataset.sxEdF === q.get('edition'))) ed = q.get('edition');
    const fb = stBtns.find((b) => b.dataset.slug && b.dataset.slug === q.get('film'));
    if (fb) st = fb.dataset.sxStF;
    apply(false);
  });
})();
